import { courseRepository } from 'data/repositories/course.repository';

export const syncCourses = async (idOrSlug: string) => {
    try {
        if (idOrSlug) {
            await courseRepository.syncCourses(idOrSlug);
        }
    } catch (error) {
        console.error(`Falha em obter curso ${idOrSlug}`, error);
    }
};
